'use client'

import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Link from 'next/link'
import AnimationComponent from '../../global/interactive/AnimationComponent'
import { spider_lottie } from '../../global/interactive/paths'
import { usePathname } from 'next/navigation'
import { cx } from '@/src/styles/stylebook'

const SpiderAnimation = () => {
  const pathname = usePathname()
  const spiderRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    if (!spiderRef.current) return

    const timeline = gsap.timeline({ repeat: -1 })

    // 1.5초동안 0.3초마다 왼쪽으로 스텝 이동 (5단계)
    timeline
      .to(spiderRef.current, { x: -20, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -40, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -60, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -80, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -100, duration: 1.5, ease: 'steps(1)' })
      // 1.5초동안 1.5초마다 오른쪽으로 스텝 복귀 (5단계)
      .to(spiderRef.current, { x: -80, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -60, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -40, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: -20, duration: 1.5, ease: 'steps(1)' })
      .to(spiderRef.current, { x: 0, duration: 1.5, ease: 'steps(1)' })

    return () => {
      timeline.kill()
    }
  }, [])

  return (
    <Link
      ref={spiderRef}
      href="/community/support-us"
      className={cx(
        'absolute -top-[calc(var(--popup)-5px)] right-0 w-32 -translate-y-full',
        (pathname.startsWith('/screening/places/') ||
          pathname.startsWith('/community/support-us') ||
          pathname.startsWith('/programs/events')) &&
          'max-md:hidden max-md:opacity-0'
      )}
    >
      <AnimationComponent
        animationData={spider_lottie}
        loop={true}
        autoplay={true}
        play
        className="h-full w-full"
      />
      <span className="h6 text-gray-0 absolute -top-[1.5em] left-1/2 -translate-x-1/2 text-center">
        Click!
      </span>
    </Link>
  )
}

export default SpiderAnimation
